//Module Keys
let locales = {};

//Merge Views
import keysFobsTab from 'Modules/keysFobs/.components/tab/lan/en';
import keysFobsMain from '../../views/main/lan/en';
import createEditKeyFob from 'Modules/keysFobs/.components/createEditKeyFob/lan/en';
import deleteKeyFob from 'Modules/keysFobs/.components/deleteKeyFob/lan/en';
import bulkAddDriverIdTags from 'Modules/keysFobs/.components/bulkAddDriverIdTags/lan/en';
import moveToAnotherAccount from 'Modules/keysFobs/.components/moveToAnotherAccount/lan/en';
import unassignDrivers from 'Modules/keysFobs/.components/unassignDrivers/lan/en';

locales = { 
    ...locales, 
    ...keysFobsTab, 
    ...keysFobsMain,
    ...createEditKeyFob,
    ...deleteKeyFob,
    ...bulkAddDriverIdTags,
    ...moveToAnotherAccount,
    ...unassignDrivers,
};

export default locales;